<template>
  <div class="personal-data">
    <div class="wrapper">
      <div class="title">管理我的账号</div>
      <div class="wrapList">
        <div
          class="item acea-row row-between-wrapper"
          :class="item.uid === userInfo.uid ? 'on' : ''"
          v-for="(item, index) in switchUserInfo"
          :key="index"
        >
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue">
              <VueCoreImageUpload
                class="btn btn-primary"
                :crop="false"
                compress="80"
                @errorhandle="errorhandle"
                @imageuploaded="imageuploaded"
                :headers="headers"
                :max-file-size="10485760"
                :credentials="false"
                inputAccept="image/*"
                inputOfFile="file"
                :url="url"
                ref="upImg"
                v-if="item.uid === userInfo.uid"
              >
                <div class="pictrue">
                  <img :src="item.avatar" />
                </div>
              </VueCoreImageUpload>
              <div class="pictrue" v-else>
                <img :src="item.avatar" />
              </div>
              <img
                src="@assets/images/alter.png"
                class="alter"
                v-if="item.uid === userInfo.uid"
              />
            </div>
            <div class="text">
              <div class="name line1">{{ item.account }}</div>
              <div class="phone">绑定手机号：{{ item.phone }}</div>
            </div>
          </div>
          <div
            class="currentBnt acea-row row-center-wrapper font-color-red"
            v-if="item.uid === userInfo.uid"
          >
            当前账号
          </div>
          <div
            class="bnt font-color-red acea-row row-center-wrapper"
            v-else
            @click="switchAccounts(index)"
          >
            使用账号
          </div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div>姓名</div>
        <div class="input">
          <input type="text" disabled v-model="userInfo.nickname" style="" />
        </div>
      </div>
      <!-- <div class="item acea-row row-between-wrapper">
        <div>ID号</div>
        <div class="input acea-row row-between-wrapper">
          <input type="text" :value="userInfo.uid" disabled class="id" /><span
            class="iconfont icon-suozi"
          ></span>
        </div>
      </div> -->
      <!-- <div class="item acea-row row-between-wrapper">
        <div>ID</div>
        <div @click="show" class="input acea-row row-between-wrapper">
          <input
            v-if="!userInfo.is_xgzh"
            type="text"
            :value="userInfo.uid"
            disabled
            class="id"
          />
          <input
            v-else
            type="text"
            :value="userInfo.uid + '(可修改)'"
            disabled
            class="id"
          />
          <span v-if="!userInfo.is_xgzh" class="iconfont icon-suozi"></span>
        </div>
      </div> -->
      <div v-if="!userInfo.phone">
        <router-link
          :to="'/user/binding'"
          class="item acea-row row-between-wrapper"
        >
          <div>绑定手机号</div>
          <div class="input">
            点击绑定手机号<span class="iconfont icon-xiangyou"></span>
          </div>
        </router-link>
      </div>
      <div class="item acea-row row-between-wrapper" v-else-if="userInfo.phone">
        <div>手机号码</div>
        <div class="input acea-row row-between-wrapper">
          <div class="input acea-row row-between-wrapper">
            <input
              type="text"
              :value="userInfo.phone"
              disabled
              class="id"
            /><span class="iconfont icon-suozi"></span>
          </div>
        </div>
      </div>
      <div v-if="userInfo.phone && userInfo.user_type === 'h5'">
        <router-link
          :to="'/change_password'"
          class="item acea-row row-between-wrapper"
        >
          <div>登录密码</div>
          <div class="input">
            点击修改登录密码<span class="iconfont icon-xiangyou"></span>
          </div>
        </router-link>
      </div>
      <div>
        <router-link
          :to="'/change_password2'"
          class="item acea-row row-between-wrapper"
        >
          <div>交易密码</div>
          <div class="input">
            点击修改交易密码<span class="iconfont icon-xiangyou"></span>
          </div>
        </router-link>
      </div>
      <div>
        <router-link
          :to="'/news_detail/2'"
          class="item acea-row row-between-wrapper"
        >
          <div>隐私协议</div>
          <div class="input">
            查看隐私协议<span class="iconfont icon-xiangyou"></span>
          </div>
        </router-link>
      </div>
      <div>
        <router-link
          :to="'/news_detail/3'"
          class="item acea-row row-between-wrapper"
        >
          <div>用户协议</div>
          <div class="input">
            查看用户协议<span class="iconfont icon-xiangyou"></span>
          </div>
        </router-link>
      </div>
      <div>
        <router-link :to="'/logout'" class="item acea-row row-between-wrapper">
          <div>注销账号</div>
          <div class="input">
            去注销<span class="iconfont icon-xiangyou"></span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="modifyBnt bg-color-red" @click="submit">保存修改</div>
    <div class="logOut cart-color acea-row row-center-wrapper" @click="logout">
      退出登录
    </div>
    <div class="mask" v-if="showmask"></div>
    <div class="win_mask" v-if="showmask">
      <div class="title">修改账号</div>
      <input type="text" placeholder="请输入需要修改的账号" v-model="xgzh" />
      <div class="btns acea-row row-center-wrapper">
        <div class="cancel" @click="showmask = false">取消</div>
        <div class="sure" @click="edit">确认</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { trim, VUE_APP_API_URL, isWeixin } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";
import {
  postUserEdit,
  getLogout,
  switchH5Login,
  getUser,
  accountEdit
} from "@api/user";
import { clearAuthStatus } from "@libs/wechat";
import cookie from "@utils/store/localStorage";
import store from "@/store";

export default {
  name: "PersonalData",
  components: {
    VueCoreImageUpload
  },
  data: function() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      showmask: false,
      avatar: "",
      xgzh: "",
      isWeixin: false,
      currentAccounts: 0,
      switchUserInfo: [],
      userIndex: 0
    };
  },
  watch: {
    $route(n) {
      if (n.name === "PersonalData") this.$store.dispatch("USERINFO", true);
    }
  },
  computed: mapGetters(["userInfo"]),
  mounted: function() {
    this.avatar = this.userInfo.avatar;
    this.isWeixin = isWeixin();
    this.getUserInfo();
  },
  methods: {
    edit() {
      if (!this.xgzh)
        return this.$dialog.toast({ mes: "请输入需要修改的账号！" });
      accountEdit({ account: this.xgzh })
        .then(res => {
          this.$dialog.toast({ mes: res.msg });
          this.getUserInfo();
          this.showmask = false;
        })
        .catch(res => {
          this.$dialog.toast({ mes: res.msg });
        });
    },
    show() {
      if (this.userInfo.is_xgzh) this.showmask = true;
    },
    switchAccounts: function(index) {
      let that = this;
      this.userIndex = index;
      let userInfo = this.switchUserInfo[this.userIndex];
      if (this.switchUserInfo.length <= 1) return true;
      if (userInfo === undefined)
        return this.$dialog.toast({ mes: "切换的账号不存在" });
      // if (userInfo.user_type === "h5") {
      switchH5Login(userInfo.account)
        .then(({ data }) => {
          that.$dialog.loading.close();
          let expires_time = data.expires_time.substring(0, 19);
          expires_time = expires_time.replace(/-/g, "/");
          expires_time = new Date(expires_time).getTime() - 28800000;
          const datas = {
            token: data.token,
            expires_time: expires_time
          };
          store.commit("LOGIN", datas);
          that.$emit("changeswitch", false);
          location.reload();
        })
        .catch(err => {
          that.$dialog.loading.close();
          return that.$dialog.toast({ mes: err });
        });
      // } else {
      //   cookie.set("loginType", "wechat", 60);
      //   this.$dialog.loading.close();
      //   this.$store.commit("LOGOUT");
      //   clearAuthStatus();
      //   this.$emit("changeswitch", false);
      //   location.reload();
      // }
    },
    getUserInfo: function() {
      let that = this;
      getUser().then(res => {
        let switchUserInfo = res.data.switchUserInfo;
        let reg = /^(\d{3})\d*(\d{4})$/;
        for (let i = 0; i < switchUserInfo.length; i++) {
          switchUserInfo[i].phone = switchUserInfo[i].phone
            ? switchUserInfo[i].phone.replace(reg, "$1****$2")
            : "";
          if (switchUserInfo[i].uid == that.userInfo.uid) that.userIndex = i;
          if (
            !that.isWeixin &&
            switchUserInfo[i].user_type != "h5" &&
            switchUserInfo[i].phone === ""
          )
            switchUserInfo.splice(i, 1);
        }
        that.userInfo.phone = that.userInfo.phone
          ? that.userInfo.phone.replace(reg, "$1****$2")
          : "";
        that.$set(this, "switchUserInfo", switchUserInfo);
      });
    },
    errorhandle() {
      this.$dialog.error("上传图片超出10M");
    },
    imageuploaded(res) {
      if (res.status !== 200) {
        if (res.msg == "Upload file does not exist") {
          return this.$dialog.error("上传图片超出10M");
        } else {
          return this.$dialog.error(res.msg || "上传图片失败");
        }
      }
      if (this.switchUserInfo[this.userIndex] === undefined) return;
      this.$set(this.switchUserInfo[this.userIndex], "avatar", res.data.url);
    },

    submit: function() {
      let userInfo = this.switchUserInfo[this.userIndex];
      postUserEdit({
        nickname: trim(this.userInfo.nickname),
        avatar: userInfo.avatar
      }).then(
        res => {
          this.$store.dispatch("USERINFO", true);
          this.$dialog.success(res.msg);
          this.$router.go(-1);
        },
        error => {
          this.$dialog.error(error.msg);
        }
      );
    },
    logout: function() {
      this.$dialog.confirm({
        mes: "确认退出登录?",
        opts: () => {
          getLogout()
            .then(res => {
              this.$store.commit("LOGOUT");
              clearAuthStatus();
              cookie.remove("spread");
              location.href = location.origin;
              console.log(res);
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.win_mask {
  width: 80vw;
  height: 40vw;
  background: #ffffff;
  border-radius: 2vw;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  position: absolute;
  z-index: 556;
  .title {
    text-align: center;
    line-height: 10vw;
  }
  input {
    border-radius: 5vw;
    height: 10vw;
    background: #eee;
    width: 60vw;
    margin: 3vw 10vw;
    text-indent: 2vw;
  }
  .btns {
    .cancel {
      width: 20vw;
      text-align: center;
      margin-right: 5vw;
      color: #ccc;
    }
    .sure {
      color: blue;
      width: 20vw;
      text-align: center;
      line-height: 10vw;
      margin-left: 5vw;
    }
  }
}
</style>
